<div class="modal-overlay" *ngIf="show">
  <div class="modal-bg" style="padding: 15px">
    <div *ngIf="isLoading" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-60">
      <!-- Spinner de carregamento -->
      <div class="border-gray-300 h-12 w-12 animate-spin rounded-full border-4 border-t-green-500"></div>
    </div>
    <div [ngClass]="{
        'stepper-container-step-1': currentStep == 1,
        'stepper-container-step-2': currentStep >= 2,
      }" [formGroup]="patientFG">
      <div class="arrow-back" *ngIf="currentStep > 1" (click)="prevStep()">
        <img src="icon-left-arrow.png" alt="Seta para esquerda - Voltar" />
        <span>Voltar</span>
      </div>
      <div [ngClass]="{
          'stepper-1': currentStep == 1,
          'stepper-2': currentStep >= 2,
        }">
        <div class="step step-1" [ngClass]="{ active: currentStep > 1 }">
          <div class="circle"></div>
          <p>Dados do Paciente</p>
        </div>
        <div class="line" [ngClass]="{ filled: currentStep >= 2 }"></div>
        <div class="step step-2" [ngClass]="{ active: currentStep > 2 }">
          <div [ngClass]="{
              'circle-2': currentStep > 2,
              'circle-1': currentStep < 2,
              'circle-step-2': currentStep == 2,
            }"></div>
          <p>Detalhes do Atendimento</p>
        </div>
      </div>
      <div class="close-or-stranger">
        <img src="icon-x-to-close.png" alt="X para fechar o modal" (click)="closeModal(); closeEmit()" />
        <div *ngIf="currentStep == 1" class="stranger-patient">
          <label for="stranger">Paciente estrangeiro</label>
          <input type="checkbox" name="stranger" id="stranger" class="cursor-pointer" formControlName="stranger"
            (click)="toggleIsStranger($event)" />
        </div>
      </div>
    </div>

    <form class="modal-register-card" [formGroup]="patientFG">
      <!-- STEP 1 -->
      <div *ngIf="currentStep == 1" class="px-5 py-1 text-black flex items-center justify-between bg-primary">
        <p class="font-semibold">Confirme os dados do paciente</p>
      </div>

      <div *ngIf="currentStep == 1"
        class="px-5 py-1 my-3 text-black flex items-center justify-between bg-primary under-age">
        <p class="font-semibold">Dados pessoais</p>
        <small *ngIf="isUnderAge()" class="under-age">menor de idade</small>
      </div>

      <div *ngIf="currentStep == 1" class="grid grid-rows-1 px-5 pt-2.5 pb-6 text-xxs">
        <div *ngIf="currentStep == 1" class="grid grid-cols-5 gap-5 pr-5">
          <div class="col-span-3 input-area flex flex-col">
            <label for="nome" class="input-label required-label">Nome completo</label>
            <input type="text" id="nome" class="input px-1" placeholder="Nome completo" formControlName="nome"
              [ngClass]="{
                'valid-input': !isFieldInvalid('nome'),
                'invalid-input': isFieldInvalid('nome'),
              }" />
            <p *ngIf="isFieldInvalid('nome')" class="input-error-message">
              Nome inválido
            </p>
          </div>
          <!-- CPF - NÃO É ESTRANGEIRO -->
          <div *ngIf="!isStranger" class="col-span-1 input-area flex flex-col">
            <label for="cpf" class="input-label" [ngClass]="{ 'required-label': !isStranger }">CPF</label>
            <input type="text" id="cpf" class="input px-1" placeholder="000.000.000-00" mask="000.000.000-00"
              formControlName="cpf" [ngClass]="{
                'valid-input': !isFieldInvalid('cpf'),
                'invalid-input': isFieldInvalid('cpf') && !isStranger,
                'disabled-input opacity-50': cpfIsAlreadyCorrectlyFilled(),
              }" [disabled]="cpfIsAlreadyCorrectlyFilled()" />
            <p *ngIf="isFieldInvalid('cpf') && !isStranger" class="input-error-message">
              CPF inválido
            </p>
          </div>
          <!-- CPF - NÃO É ESTRANGEIRO -->
          <!-- RNE - ESTRANGEIRO -->
          <div *ngIf="patientFG.get('documentoEstrangeiro')?.value === 'RNM_RNE' && isStranger"
            class="col-span-1 input-area flex flex-col">
            <label for="rne" class="input-label" [ngClass]="{ 'required-label' : isStranger }">RNM/RNE</label>
            <input type="text" id="rne" class="input px-1" formControlName="rne" [ngClass]="{
              'valid-input':!isFieldInvalid('rne'),
              'invalid-input':isFieldInvalid('rne')
            }" />
            <p *ngIf="isFieldInvalid('rne')" class="input-error-message">Campo inválido.</p>
          </div>
          <!-- RNE - ESTRANGEIRO -->
          <!-- PASSPORTE - ESTRANGEIRO -->
          <div *ngIf="patientFG.get('documentoEstrangeiro')?.value === 'PASSPORT' && isStranger"
            class="col-span-1 input-area flex flex-col">
            <label for="passport" class="input-label" [ngClass]="{ 'required-label' : isStranger }">Passaporte</label>
            <input type="text" id="passport" class="input px-1" formControlName="passport" [ngClass]="{
              'valid-input':!isFieldInvalid('passport'),
              'invalid-input':isFieldInvalid('passport')
            }" />
            <p *ngIf="isFieldInvalid('passport')" class="input-error-message">Campo inválido.</p>
          </div>
          <!-- PASSPORTE - ESTRANGEIRO -->
          <div class="col-span-1 input-area flex flex-col">
            <label for="dtNascimento" class="input-label required-label">Data de nascimento</label>
            <input type="date" id="dtNascimento" class="input px-1" formControlName="dtNascimento" />
            <p *ngIf="isUnderAge()" class="input-error-message input-error-message-secondary">
              Menor de idade. Adicione um responsável.
            </p>
            <p *ngIf="isFieldInvalid('dtNascimento')" class="input-error-message">
              Data inválida
            </p>
          </div>

          <div class="col-span-3 input-area flex flex-col">
            <label for="nomeSocial" class="input-label">Nome Social / Afetivo</label>
            <input type="text" id="nomeSocial" class="input px-1" formControlName="nomeSocial" placeholder="Nome social"
              (input)="onNomeSocialInput($event)"
              [ngClass]="{
                'valid-input': !isFieldInvalid('nomeSocial'),
                'invalid-input': isFieldInvalid('nomeSocial'),
              }" />
            <p *ngIf="isFieldInvalid('nomeSocial')" class="input-error-message">
              {{ MENSAGEM_NOME_SOCIAL_INVALIDO }}
            </p>
          </div>

          <div class="col-span-2 input-area flex flex-col">
            <label for="sexo" class="input-label required-label">Sexo</label>
            <select id="sexo" class="input px-1" formControlName="sexo" [ngClass]="{
                'valid-input': !isFieldInvalid('sexo'),
                'invalid-input': isFieldInvalid('sexo'),
              }">
              <option value="" disabled selected>Selecione</option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
              <option value="indefinido">Indefinido</option>
            </select>
            <p *ngIf="isFieldInvalid('sexo')" class="input-error-message">
              Campo inválido
            </p>
          </div>

          <div class="col-span-1 input-area flex flex-col">
            <label for="telefone1" class="input-label required-label">Telefone</label>
            <input type="text" id="telefone1" class="input px-1" prefix="+55 " placeholder="(00) 00000-0000"
              mask="(00) 00000-0000||(00) 0000-0000" formControlName="telefone1" [ngClass]="{
                'valid-input': !isFieldInvalid('telefone1'),
                'invalid-input': isFieldInvalid('telefone1'),
              }" />
            <p *ngIf="isFieldInvalid('telefone1')" class="input-error-message">
              Telefone inválido
            </p>
          </div>

          <div class="col-span-2 input-area flex flex-col">
            <label for="patientEmail" class="input-label required-label">Email</label>
            <input type="text" id="patientEmail" class="input px-1" placeholder="mail@mail.com"
              formControlName="patientEmail" [ngClass]="{
                'valid-input': !patientFG.get('dontHaveEmail')?.value && !isFieldInvalid('patientEmail'),
                'invalid-input': !patientFG.get('dontHaveEmail')?.value && isFieldInvalid('patientEmail'),
                'disabled-input opacity-50': patientFG.get('dontHaveEmail')?.value
              }" />

            <p *ngIf="isFieldInvalid('patientEmail') && !dontHaveEmail" class="input-error-message">
              Email inválido.
            </p>
          </div>

          <div class="col-span-1 input-area flex flex-row dont-have-email">
            <input type="checkbox" name="dontHaveEmail" id="dontHaveEmail" class="cursor-pointer"
              formControlName="dontHaveEmail" />
            <label for="dontHaveEmail" class="font-semibold text-xs -mb-0.5 cursor-pointer">Não possui email</label>
          </div>

          <div class="col-span-1 input-area flex flex-col">
            <label for="estadoCivil" class="input-label">Estado Civil</label>
            <select name="estadoCivil" id="estadoCivil" class="input px-1" formControlName="estadoCivil" [ngClass]="{
                'valid-input': !isFieldInvalid('estadoCivil'),
                'invalid-input': isFieldInvalid('estadoCivil'),
              }">
              <option value="" disabled selected>Selecione</option>
              <option value="casado">Casado</option>
              <option value="concubinado">Concubinado/União Estável</option>
              <option value="desquitado">Desquitado</option>
              <option value="divorciado">Divorciado</option>
              <option value="outros">Outros</option>
              <option value="separado">Separado</option>
              <option value="solteiro">Solteiro</option>
              <option value="viuvo">Viúvo</option>
            </select>
            <p *ngIf="isFieldInvalid('estadoCivil')" class="input-error-message">
              Campo inválido
            </p>
          </div>
        </div>

        <div class="reponsavel-field">
          <div class="my-5 py-1 text-black flex items-center justify-between bg-primary">
            <p class="font-semibold">Dados do responsável</p>
          </div>
          <div class="col-span-4 input-area flex flex-col responsavel-grid">
            <label for="nomeResponsavel" class="input-label" [ngClass]="{ 'required-label':isStranger || isUnderAge() }"
              style="grid-column: span 2">Nome do
              responsável</label>
            <label for="cpfResponsavel" class="input-label"
              [ngClass]="{ 'required-label':isStranger || isUnderAge() }">CPF do
              responsável</label>
            <input style="grid-column: span 2" type="text" id="nomeResponsavel" class="input border-gray-500 px-1"
              placeholder="Nome completo" formControlName="nomeResponsavel" [ngClass]="{
                'border-secondary': !isFieldInvalid('nomeResponsavel'),
                'invalid-input': isFieldInvalid('nomeResponsavel'),
              }" />
            <p *ngIf="!isStranger && isFieldInvalid('nomeResponsavel')" class="input-error-message">
              Nome inválido.
            </p>
            <p *ngIf="isStranger && isFieldInvalid('nomeResponsavel')" class="input-error-message">Nome do responsável é
              obrigatório para estrangeiros.</p>
            <input type="text" id="cpfResponsavel" class="input border-gray-500 px-1" formControlName="cpfResponsavel"
              placeholder="000.000.000-00" mask="000.000.000-00" [ngClass]="{
                'border-secondary': !responsibleCpfHandle(),
                'invalid-input': responsibleCpfHandle(),
              }" />
            <p *ngIf="!isStranger && responsibleCpfHandle()" class="input-error-message">
              {{
              isFieldInvalid("cpfResponsavel") || isSameCpfOfPatient()
              ? "CPF inválido. Não é possível cadastrar os mesmo dados do paciente menor de idade."
              : "Você deve cadastrar o responsável"
              }}
            </p>
            <p *ngIf="isStranger && isFieldInvalid('cpfResponsavel')" class="input-error-message">CPF do responsável é
              obrigatório para estrangeiros.</p>
          </div>
        </div>

        <div *ngIf="currentStep == 1" class="py-1 my-5 text-black flex items-center justify-between bg-primary">
          <p class="font-semibold">Endereço</p>
        </div>

        <div class="grid grid-cols-5 gap-5">
          <div *ngIf="currentStep == 1" class="col-span-1 input-area flex flex-col">
            <label for="cep" class="input-label required-label">CEP</label>
            <input type="text" id="cep" class="input px-1" mask="00000-000" placeholder="00000-000"
              formControlName="cep" [ngClass]="{
                'valid-input': !isFieldInvalid('cep'),
                'invalid-input': isFieldInvalid('cep'),
              }" />
            <p *ngIf="isFieldInvalid('cep')" class="input-error-message">
              CEP inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-2 input-area flex flex-col">
            <label for="endereco" class="input-label required-label">Endereço</label>
            <input type="text" id="endereco" class="input px-1" placeholder="Endereço" formControlName="endereco"
              [ngClass]="{
                'valid-input': !isFieldInvalid('endereco'),
                'invalid-input': isFieldInvalid('endereco'),
              }" />
            <p *ngIf="isFieldInvalid('endereco')" class="input-error-message">
              Endereço inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-1 input-area flex flex-col">
            <label for="numero" class="input-label required-label">Número</label>
            <input type="text" id="numero" class="input px-1" placeholder="0000" formControlName="numero" [ngClass]="{
                'valid-input': !isFieldInvalid('numero'),
                'invalid-input': isFieldInvalid('numero'),
              }" />
            <p *ngIf="isFieldInvalid('numero')" class="input-error-message">
              Campo inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-1 input-area flex flex-col">
            <label for="bairro" class="input-label required-label">Bairro</label>
            <input type="text" id="bairro" class="input px-1" placeholder="Bairro" formControlName="bairro" [ngClass]="{
                'valid-input': !isFieldInvalid('bairro'),
                'invalid-input': isFieldInvalid('bairro'),
              }" />
            <p *ngIf="isFieldInvalid('bairro')" class="input-error-message">
              Bairro inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-3 input-area flex flex-col">
            <label for="complemento" class="input-label">Complemento</label>
            <input type="text" id="complemento" class="input px-1" placeholder="Complemento"
              formControlName="complemento" [ngClass]="{
                'valid-input': !isFieldInvalid('complemento'),
                'invalid-input': isFieldInvalid('complemento'),
              }" />
            <p *ngIf="isFieldInvalid('complemento')" class="input-error-message">
              Complemento inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-1 input-area flex flex-col">
            <label for="estado" class="input-label required-label">Estado</label>
            <select name="estado" id="estado" class="input px-1" formControlName="estado" [ngClass]="{
                'valid-input': !isFieldInvalid('estado'),
                'invalid-input': isFieldInvalid('estado'),
              }">
              <option value="" disabled selected>Selecione</option>
              <option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</option>
            </select>
            <p *ngIf="isFieldInvalid('estado')" class="input-error-message">
              Estado inválido.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-1 input-area flex flex-col">
            <label for="cidade" class="input-label required-label">Cidade</label>
            <input type="text" id="cidade" class="input px-1" placeholder="Cidade" formControlName="cidade" [ngClass]="{
                'valid-input': !isFieldInvalid('cidade'),
                'invalid-input': isFieldInvalid('cidade'),
              }" />
            <p *ngIf="isFieldInvalid('cidade')" class="input-error-message">
              Cidade inválida.
            </p>
          </div>

          <div *ngIf="currentStep == 1" class="col-span-6 grid grid-cols-1 gap-2 btn-continue">
            <button class="btn-base-right" [ngClass]="{
                'bg-gray-300 filter-none cursor-default disabled':
                  isButtonInactive(),
                'filter hover:brightness-75 cursor-pointer bg-primary enabled':
                  !isButtonInactive(),
              }" (click)="!isButtonInactive() && registerPatient()">
              Continuar
            </button>
          </div>
        </div>
      </div>

      <!-- STEP 1 -->

      <!-- STEP 2 - DETALHES DO AGENDAMENTO -->

      <h1 *ngIf="currentStep == 2" class="step-2-title pad-20-px">
        Detalhes do atendimento
      </h1>

      <div class="attendance-and-payment pad-20-px">
        <div *ngIf="currentStep == 2" class="convent-and-plan-field">
          <div class="convent-field input-field">
            <label for="convenant" class="input-label required-label">Convênio</label>
            <input type="text" id="convenant" class="input px-1 input-step-2" placeholder="Convênio" disabled
              [value]="covenant" [ngClass]="{
                'valid-input': !isFieldInvalid('convenant'),
                'invalid-input': isFieldInvalid('convenant'),
              }" />
          </div>

          <div *ngIf="covenant.toUpperCase() !== 'PARTICULAR'" class="plan-field input-field">
            <label for="plan" class="input-label required-label">Plano</label>
            <input type="text" id="plan" class="input px-1 input-step-2" placeholder="Plano" disabled [value]="category"
              [ngClass]="{
                'valid-input': !isFieldInvalid('plan'),
                'invalid-input': isFieldInvalid('plan'),
              }" />
          </div>
        </div>

        <!-- Caso não seja autorizado a aplicar cupom. -->
        <div *ngIf="currentStep == 2 && !canApplyVoucher" class="coupon-field input-field">
          <label for="coupon" class="input-label">Cupons disponíveis</label>
          <input type="text" id="coupon" class="input px-1 input-step-2" placeholder="Cupom 1, Cupom 2, Cupom 3"
            disabled [value]="voucherNames" [ngClass]="{
              'valid-input': !isFieldInvalid('coupon'),
              'invalid-input': isFieldInvalid('coupon'),
            }" />
          <span class="coupon-span">Você pode aplicar o cupons pela Agenda Integrada antes de concluir
            o pagamento.</span>
        </div>
        <!--  -->

        <!-- Caso seja autorizado a aplicar cupom. -->
        <div *ngIf="currentStep == 2 && canApplyVoucher" class="coupon-field input-field">
          <label for="coupon" class="input-label">Aplicar cupom</label>
          <div class="input-with-button">
            <select id="coupon" class="input px-1 input-step-2" formControlName="selectedVoucher">
              <option [ngValue]="null" disabled selected>
                {{
                vouchers.length > 0
                ? "Selecione o cupom para aplicar"
                : "O cliente não tem cupons disponíveis"
                }}
              </option>
              <option *ngFor="let voucher of vouchers" [ngValue]="voucher">
                {{ voucher.voucherName }}
              </option>
            </select>
            <button class="apply-coupon-btn" (click)="applyVoucher()"
              [disabled]="!patientFG.get('selectedVoucher')!.value">
              Aplicar
            </button>
          </div>
          <span *ngIf="appliedVoucherName" class="coupon-span">Cupom aplicado: {{ appliedVoucherName }}</span>
        </div>
        <!--  -->
      </div>

      <h1 *ngIf="currentStep == 2" class="pad-20-px values-and-payment-title">
        Valores e pagamento
      </h1>
      <div *ngIf="currentStep == 2" class="values-and-payment pad-20-px">
        <div class="specialty">{{ specialtyName }}</div>
        <div class="plan-and-value">
          <div class="patient-plan-price">
            <span>{{ category }}</span>
            <span *ngIf="
                covenant.toUpperCase() === 'PARTICULAR' ||
                discountedPrice === null
              "><strong>R$ {{ specialtyPrice }},00</strong></span>
            <span *ngIf="
                covenant.toUpperCase() !== 'PARTICULAR' &&
                discountedPrice !== null
              ">
              <strong style="text-decoration: line-through; color: #888">R$ {{ specialtyPrice }},00</strong>
              <strong> R$ {{ discountedPrice }},00</strong>
            </span>
          </div>
          <div *ngIf="covenant.toUpperCase() === 'PARTICULAR'" class="black-price">
            <span>SiM+ Black</span>
            <span *ngIf="discountedPrice === null"><strong>R$ {{ blackPrice }},00</strong></span>
            <span *ngIf="discountedPrice !== null">
              <strong style="text-decoration: line-through; color: #888">R$ {{ blackPrice }},00</strong>
              <strong> R$ {{ discountedPrice }},00</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="
          currentStep == 2 && !isExamOrGyn && scheduleClassification !== 'R'
        " class="btn-payment-group pad-20-px">
        <h2 class="btns-group-title">Selecione a forma de pagamento:</h2>
        <div class="btns">
          <button class="payment-type-btn" (click)="postWhereAttendance(2)">
            Dinheiro
          </button>
          <button class="payment-type-btn" (click)="postWhereAttendance(3)">
            Cartão de Crédito e Débito
          </button>
          <button class="payment-type-btn" (click)="postWhereAttendance(3)">
            Pix
          </button>
        </div>
      </div>

      <!-- Caso seja EXAME -->
      <div *ngIf="
          currentStep == 2 && isExamOrGyn && scheduleClassification !== 'R'
        " class="btn-payment-group pad-20-px">
        <div class="btns">
          <button class="payment-type-btn" (click)="postWhereAttendance(1)">
            Continuar
          </button>
        </div>
      </div>

      <!-- Caso seja RETORNO -->
      <div *ngIf="currentStep == 2 && scheduleClassification === 'R'" class="btn-payment-group pad-20-px">
        <div class="btns">
          <button class="payment-type-btn" (click)="postWhereAttendance(3)">
            Continuar
          </button>
        </div>
      </div>

      <!-- STEP 2 -->

      <!-- STEP 3 - ADICIONAR PROCEDIMENTOS OU CONTINUAR -->
      <div *ngIf="currentStep == 3" class="step-3-budget-container pad-20-px">
        <p class="budget-info-text">
          Para adicionar novas prescrições ao atendimento, clique no botão abaixo.
        </p>
        <button style="width: 300px; height: 50px;" class="budget-button" (click)="goToAddProceduresStep()">
          Adicionar procedimentos
        </button>
        <button class="budget-button-skip" (click)="skipToFinalStep()">
          Concluir sem adicionar
        </button>
      </div>
      <!-- END STEP 3 -->

      <!-- STEP 5 - RESUMO DOS PROCEDIMENTOS -->
      <div *ngIf="currentStep == 5" class="step-5-summary-container pad-20-px">
        <!-- Cabeçalho -->
        <div class="summary-header">
          <h1 class="step-2-title">Resumo dos procedimentos</h1>
        </div>
        <div class="summary-buttons">
          <button class="add-budget-flexible-button" (click)="toggleAddBudget(); getBudgets()">
            {{ showAddBudget ? "Fechar" : "+ Adicionar orçamento" }}
          </button>

          <button class="add-budget-flexible-button" (click)="toggleAddSingleProcedure(); getAvailableProcedures()">
            {{ showAddSingleProcedure ? "Fechar" : "+ Adicionar procedimento avulso" }}
          </button>
        </div>

        <!-- Área para adicionar outro orçamento -->
        <div *ngIf="showAddBudget" class="add-budget-box">
          <p class="budget-info-text">
            Selecione um orçamento para adicionar:
          </p>
          <div class="budget-control-row">
            <select class="budget-select" [(ngModel)]="selectedBudgetId" [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" disabled>Selecione um orçamento</option>
              <option *ngFor="let budget of budgets" [ngValue]="budget" [disabled]="selectedBudgetIds.includes(budget)">
                {{ budget }}
              </option>
            </select>

            <button class="budget-button" (click)="addAnotherBudget()" [disabled]="selectedBudgetId === null">
              Adicionar procedimentos
            </button>
          </div>
        </div>

        <!-- Área para adicionar procedimento avulso -->
        <div *ngIf="showAddSingleProcedure" class="add-single-procedure-box">
          <p class="budget-info-text">
            Selecione um procedimento:
          </p>
          <div class="budget-control-row">
            <select class="budget-select" [(ngModel)]="selectedSingleProcedureId"
              [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" disabled>Selecione um procedimento</option>
              <option *ngIf="isLoading && !isAvailableProceduresLoaded" disabled>Carregando procedimentos...</option>
              <option *ngFor="let proc of availableProcedures" [ngValue]="proc.procedureId">
                {{ proc.procedureName }}
              </option>
            </select>

            <button class="budget-button" (click)="addSingleProcedureToSummary()"
              [disabled]="selectedSingleProcedureId === null">
              Adicionar procedimento
            </button>
          </div>
        </div>
        <!-- CASO PRECISE REMOVER/INATIVAR O PROCEDIMENTO AGENDADO -->
        <div *ngIf="inCaseToRemove !== ''" class="procedure-item">
          <div class="procedure-header">
            <p>Procedimento agendado:</p>
            <div class="procedure-name-container">
              <span>{{ inCaseToRemove }}</span>
            </div>
            <button *ngIf="!isEditingInCaseToRemove" (click)="toggleEditInCaseToRemove()">
              Editar
            </button>
            <button *ngIf="isEditingInCaseToRemove" (click)="updateScheduledProcedureExecutor()">
              Salvar
            </button>
          </div>
          <div *ngIf="isEditingInCaseToRemove" class="procedure-edit-form">
            <small class="laboratorial-exam">
              Este é o procedimento agendado do paciente.
            </small>

            <select [(ngModel)]="doctorIdToUpdate" [ngModelOptions]="{ standalone: true }" class="input px-1">
              <option value="" disabled>Selecione um médico</option>
              <option *ngFor="let doctor of doctors" [value]="doctor.doctorId">
                {{ doctor.doctorName }}
              </option>
            </select>

            <button (click)="requestDeleteScheduledProcedure()" class="delete-procedure-btn">
              Excluir
            </button>
          </div>
        </div>
        <!-- CASO PRECISE REMOVER/INATIVAR O PROCEDIMENTO AGENDADO -->

        <!-- Lista de procedimentos -->
        <div *ngFor="let procedure of procedures" class="procedure-item">
          <div class="procedure-header">
            <div class="procedure-name-container">
              <span>{{ procedure.name }}</span>
              <small class="laboratorial-exam" *ngIf="procedure.executor">
                Médico selecionado: {{ procedure.executor }}.
              </small>
              <small *ngIf="!procedure.executor && procedure.isLaboratorialExam" class="laboratorial-exam">
                Médico selecionado: Laboratório Pardini.
              </small>
            </div>

            <button (click)="toggleEdit(procedure)">
              {{ procedure.editing ? "Salvar" : "Editar" }}
            </button>
          </div>

          <div *ngIf="procedure.editing" class="procedure-edit-form">
            <label for="medico-executor-{{ procedure.id }}">
              Médico Executor
            </label>

            <select id="medico-executor-{{ procedure.id }}"
              [(ngModel)]="procedure.executor"
              [ngModelOptions]="{ standalone: true }"
              class="input px-1">
              <option value="" disabled>Selecione um médico</option>
              <option *ngFor="let doctor of doctors" [value]="doctor.doctorName">
                {{ doctor.doctorName }}
              </option>
            </select>

            <div class="quantity-control">
              <button (click)="decrementQuantity(procedure)" class="quantity-button">-</button>
              <span class="quantity-display">{{ procedure.quantity }}</span>
              <button (click)="incrementQuantity(procedure)" class="quantity-button">+</button>
            </div>

            <button (click)="requestDelete(procedure)" class="delete-procedure-btn">
              Excluir
            </button>
          </div>
        </div>

        <div class="btn-continue-step5">
          <button class="budget-button" (click)="addProceduresToCheckIn()" [disabled]="isLoading">
            Continuar
          </button>
        </div>
      </div>
      <!-- END STEP 5 -->

      <!-- STEP 6 - CONCLUIR ATENDIMENTO -->
      <div *ngIf="currentStep == 6" class="step-6-final-confirmation pad-20-px">
        <h1>Concluir abertura de atendimento</h1>
        <span>Siga para a Agenda Integrada e realize o pagamento do atendimento.
          Após o pagamento, retorne a essa tela para finalizar a senha.</span>
        <div class="section-checkbox">
          <input type="checkbox" id="confirmOpenAttendance" [(ngModel)]="confirmOpenAttendance"
            [ngModelOptions]="{ standalone: true }" />
          <label for="confirmOpenAttendance">Confirmo que quero concluir a abertura de atendimento</label>
        </div>
        <div class="btn-open-attendance flex flex-col gap-2">
          <button (click)="finishExamCheckIn(false)" [disabled]="!confirmOpenAttendance" [ngClass]="{
              'open-attendance': confirmOpenAttendance,
              'open-attendance-disabled': !confirmOpenAttendance,
            }">
            Concluir atendimento
          </button>
          <button (click)="finishExamCheckIn(true)" [disabled]="!confirmOpenAttendance" [ngClass]="{
              'discount-button-active': confirmOpenAttendance,
              'discount-button-disabled': !confirmOpenAttendance
            }">
            Concluir e solicitar desconto PEP
          </button>
        </div>
      </div>
      <!-- END STEP 6 -->

      <!-- STEP 7 - ABERTURA INICIAL -->
      <div *ngIf="currentStep == 7" class="step-3-finalization pad-20-px">
        <div class="section-info">
          <!-- Abertura de exame: -->
          <h1 *ngIf="whereAttendance == 1" class="step-3-title">
            O atendimento será aberto inicialmente até a prescrição
          </h1>
          <!-- Abertura de consulta em dinheiro: -->
          <h1 *ngIf="whereAttendance == 2" class="step-3-title">
            O atendimento será aberto por completo
          </h1>
          <!-- Abertura de consulta em cartão/pix: -->
          <h1 *ngIf="whereAttendance == 3" class="step-3-title">
            O atendimento será aberto por completo
          </h1>

          <!-- Pagamento de exame: -->
          <span *ngIf="whereAttendance == 1 && scheduleClassification !== 'R'" class="span-step-3">Prossiga para
            gerenciar os procedimentos ou concluir o
            atendimento.</span>
          <!-- Pagamento de consulta em dinheiro: -->
          <span *ngIf="whereAttendance == 2 && scheduleClassification !== 'R'" class="span-step-3">Siga para o pagamento
            do atendimento. Após o pagamento, retorne a
            essa tela para finalizar a senha.</span>
          <!-- Pagamento de consulta em cartã ou pix: -->
          <span *ngIf="whereAttendance == 3 && scheduleClassification !== 'R'" class="span-step-3">Siga para a Agenda
            Integrada e realize o pagamento do atendimento.
            Após o pagamento, retorne a essa tela para finalizar a senha.</span>
          <!-- Pagamento de retorno: -->
          <span *ngIf="scheduleClassification === 'R' && whereAttendance !== 1" class="span-step-3">Para retornos, não
            há pagamento. Após abrir o atendimento, o
            paciente vai direto para a fila do médico.</span>
        </div>
        <div class="section-checkbox">
          <input class="ng-valid ng-dirty ng-touched" type="checkbox" name="confirme" id="confirme"
            (change)="toggleOpenAttendance()" />
          <!-- Abertura de exame: -->
          <label *ngIf="whereAttendance == 1 && scheduleClassification !== 'R'" for="confirme">Confirmo que quero abrir
            o atendimento inicialmente até a
            prescrição</label>
          <!-- Abertura de consulta em dinheiro / cartão / pix: -->
          <label *ngIf="
              (whereAttendance == 2 || whereAttendance == 3) &&
              scheduleClassification !== 'R'
            " for="confirme">Confirmo que quero abrir o atendimento por completo</label>
          <!-- Abertura de retorno: -->
          <label *ngIf="scheduleClassification === 'R'" for="confirme">Confirmo que quero abrir o atendimento de
            retorno</label>
        </div>
        <!-- Abertura de exame: -->
        <div *ngIf="whereAttendance == 1 && scheduleClassification !== 'R'" class="btn-open-attendance">
          <button (click)="openAttendance()" [ngClass]="{
              'open-attendance': enableOpenAttendace,
              'open-attendance-disabled': !enableOpenAttendace,
            }" [disabled]="!enableOpenAttendace">
            Abrir atendimento até prescrição
          </button>
        </div>
        <!-- Abertura de consulta em dinheiro / cartão / pix: -->
        <div *ngIf="
            (whereAttendance == 2 || whereAttendance == 3) &&
            scheduleClassification !== 'R'
          " class="btn-open-attendance">
          <button (click)="openAttendance()" [ngClass]="{
              'open-attendance': enableOpenAttendace,
              'open-attendance-disabled': !enableOpenAttendace,
            }" [disabled]="!enableOpenAttendace">
            Mudar status para "Aguardando consulta"
          </button>
        </div>
        <!-- Abertura de retorno: -->
        <div *ngIf="scheduleClassification === 'R'" class="btn-open-attendance">
          <button (click)="openAttendance()" [ngClass]="{
              'open-attendance': enableOpenAttendace,
              'open-attendance-disabled': !enableOpenAttendace,
            }" [disabled]="!enableOpenAttendace">
            Abrir atendimento de retorno
          </button>
        </div>
      </div>

      <!-- DELETE CONFIRMATION MODAL -->
      <div class="error-attendance-modal" *ngIf="showDeleteConfirmation">
        <div class="error-attendance-modal-content">
          <div class="title-error-attendance-modal">
            <p>Excluir procedimento</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>Isso é definitivo. Tem certeza?</p>
          </div>
          <div class="btn-delete-confirmation">
            <button (click)="cancelDelete()">Cancelar</button>
            <button (click)="confirmDelete()">Excluir</button>
          </div>
        </div>
      </div>
      <!-- END DELETE CONFIRMATION MODAL -->

      <!-- DELETE SCHEDULED PROCEDURE CONFIRMATION MODAL -->
      <div class="error-attendance-modal" *ngIf="showDeleteScheduledProcedureConfirmation">
        <div class="error-attendance-modal-content">
          <div class="title-error-attendance-modal">
            <p>Excluir procedimento agendado</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>Isso é definitivo. Tem certeza?</p>
          </div>
          <div class="btn-delete-confirmation">
            <button (click)="cancelDeleteScheduledProcedure()">Cancelar</button>
            <button (click)="confirmDeleteScheduledProcedure()">Excluir</button>
          </div>
        </div>
      </div>
      <!-- END DELETE SCHEDULED PROCEDURE CONFIRMATION MODAL -->

      <!-- DUPLICATE PROCEDURE WARNING MODAL -->
      <div class="error-attendance-modal" *ngIf="showDuplicateProcedureWarning">
        <div class="error-attendance-modal-content duplicate-warning-content">
          <div class="title-error-attendance-modal">
            <p>Procedimentos duplicados</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>Os seguintes procedimentos estão duplicados na lista:</p>
            <ul class="duplicate-list">
              <li *ngFor="let name of duplicateProcedureNames">{{ name }}</li>
            </ul>
            <p class="duplicate-question">Deseja prosseguir mesmo assim ou voltar para corrigir?</p>
          </div>
          <div class="btn-delete-confirmation duplicate-warning-buttons">
            <button (click)="showDuplicateProcedureWarning = false">Voltar para corrigir</button>
            <button (click)="addProceduresToCheckIn(true)" [disabled]="isLoading">Prosseguir mesmo assim</button>
          </div>
        </div>
      </div>
      <!-- END DUPLICATE PROCEDURE WARNING MODAL -->

      <!-- ERROR MODAL -->
      <div class="error-attendance-modal" *ngIf="errorModal">
        <div class="error-attendance-modal-content">
          <div class="title-error-attendance-modal">
            <p>Ops...</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>
              {{ errorMessage }}
            </p>
          </div>
          <div class="btn-close">
            <button (click)="closeErrorModal()">Fechar</button>
          </div>
        </div>
      </div>
      <!-- ERROR MODAL -->

      <!-- ERROR FORM MODAL -->
      <div class="error-attendance-modal" *ngIf="errorFormModal">
        <div class="error-attendance-modal-content">
          <div class="title-error-attendance-modal">
            <p>Ops...</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>
              {{ errorFormMessage }}
            </p>
          </div>
          <div class="btn-close">
            <button (click)="closeErrorModal()">Fechar</button>
          </div>
        </div>
      </div>
      <!-- ERROR FORM MODAL -->

      <!-- RESPONSIBLE ERROR MODAL -->
      <div class="modal-backdrop" *ngIf="showResponsibleModal">
        <div class="modal-container">
          <h2 class="modal-title">Responsável não cadastrado</h2>

          <p class="modal-text">
            O CPF do responsável informado não está cadastrado no sistema.
            <br />
            Para prosseguir, é necessário realizar o cadastro do responsável ou utilizar um CPF já cadastrado.
          </p>

          <button type="button" class="modal-button" (click)="closeResponsibleModal()">
            Entendido
          </button>
        </div>
      </div>
      <!-- RESPONSIBLE ERROR MODAL -->

      <!-- MODAL INFORMATIVO PARA CAMPOS DO ESTRANGEIRO -->
      <div *ngIf="showStrangerInfosModal" id="modalEstrangeiro" class="modal">
        <div class="modal-content">
          <h2 class="stranger-info-title">Identificação de Estrangeiro</h2>
          <p class="intro-text">Siga a ordem de preferência assim podemos garantir a unicidade do cadastro deste
            paciente.</p>
          <p style="margin-bottom: 15px">Selecione com qual documento irá prosseguir:</p>

          <div class="priority-list">
            <div class="item">
              <span class="badge gold">1ª Opção</span>
              <strong>CPF</strong>
              <p>Caso o paciente estrangeiro tenha CPF, opte pelo CPF, é prioridade máxima para fins fiscais e
                contratos. (Nesse caso pode desmarcar a opção de "Estrangeiro")</p>
            </div>

            <div class="item">
              <label for="rnmRneRadio">
                <span class="badge silver">2ª Opção</span>
                <strong>RNM / RNE</strong>
              </label>
              <input style="margin-left: 5px;" type="radio" id="rnmRneRadio" name="documentoEstrangeiro"
                formControlName="documentoEstrangeiro" value="RNM_RNE" class="cursor-pointer"
                (change)="onDocumentoChange('RNM_RNE')" />
              <p>Identidade oficial de residentes no Brasil. Nesse caso também será necessário preenchar os campos de
                responsável para fins fiscais.</p>
            </div>

            <div class="item">
              <label for="passportRadio">
                <span class="badge bronze">3ª Opção</span>
                <strong>Passaporte</strong>
              </label>
              <input style="margin-left: 5px;" type="radio" id="passportRadio" name="documentoEstrangeiro"
                formControlName="documentoEstrangeiro" value="PASSPORT" class="cursor-pointer"
                (change)="onDocumentoChange('PASSPORT')" />
              <p>Use apenas para turistas ou se não houver os anteriores. Nesse caso também será necessário preenchar os
                campos de responsável para fins fiscais.</p>
            </div>
          </div>

          <button (click)="closeStrangerInfosModal()" class="btn-entendido">Prosseguir</button>
        </div>
      </div>
      <!-- MODAL INFORMATIVO PARA CAMPOS DO ESTRANGEIRO -->

      <!-- SUCCESS MODAL -->
      <div class="success-attendance-modal" *ngIf="successModal">
        <div class="success-attendance-modal-content">
          <div class="title-error-attendance-modal">
            <p>Sucesso!</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>
              {{ successMessage }}
            </p>
          </div>
          <div class="btn-close">
            <button (click)="closeSuccessModal()">Fechar</button>
          </div>
        </div>
      </div>
      <!-- SUCCESS MODAL -->

      <!-- VOUCHER STATUS MODAL -->
      <div [ngClass]="{
          'success-attendance-modal': voucherModalSuccess,
          'error-attendance-modal': !voucherModalSuccess
        }" *ngIf="voucherModal">
        <div [ngClass]="{
            'success-attendance-modal-content': voucherModalSuccess,
            'error-attendance-modal-content': !voucherModalSuccess
          }">
          <div class="title-error-attendance-modal">
            <p>{{ voucherModalTitle }}</p>
          </div>
          <div class="info-error-attendance-modal">
            <p>
              {{ voucherModalMessage }}
            </p>
          </div>
          <div class="btn-close">
            <button (click)="closeVoucherModal()">Fechar</button>
          </div>
        </div>
      </div>
      <!-- VOUCHER STATUS MODAL -->

      <!-- STEP 10 - IMPRIMIR FICHA -->
      <div *ngIf="currentStep == 10" class="finish-password-modal">
        <div class="finish-password-content">
          <div>
            <p class="title-finish-password">Imprimir ficha de atendimento</p>
          </div>
          <div class="btn-finish-password" style="display: flex; flex-direction: column; gap: 10px">
            <button (click)="downloadExamGuide()"
              class="text-white px-4 py-2 rounded bg-purple-600 hover:bg-purple-500 cursor-pointer">
              Imprimir ficha
            </button>
            <button (click)="currentStep = 8"
              class="text-white px-4 py-2 rounded bg-green-600 hover:bg-green-500 cursor-pointer">
              Finalizar Senha
            </button>
          </div>
        </div>
      </div>
      <!-- END STEP 10 -->

      <!-- STEP 8 - FINALIZAR SENHA -->
      <div *ngIf="currentStep == 8" class="finish-password-modal">
        <div class="finish-password-content">
          <div>
            <p class="title-finish-password">Pagamento</p>
          </div>
          <div class="text-finish-password">
            <label class="label-finish-password">Realize o pagamento antes de finalizar a senha</label>
          </div>
          <div class="btn-finish-password">
            <button (click)="currentStep = 9"
              class="text-white px-4 py-2 rounded bg-purple-600 hover:bg-purple-500 cursor-pointer">
              Finalizar Senha
            </button>
          </div>
        </div>
      </div>

      <div class="finish-password-modal" *ngIf="currentStep == 9">
        <div class="finish-password-content">
          <div>
            <p class="title-finish-password">Finalizar senha</p>
          </div>
          <div class="text-finish-password">
            <input type="checkbox" class="text-purple-600 bg-gray-100 border-gray-300 rounded" name="encerrar-senha"
              id="encerrar-senha" (change)="onCheckboxChange($event)" />
            <label class="label-finish-password" for="encerrar-senha">Confirmo que realizei o pagamento e quero encerrar
              a senha</label>
          </div>
          <div class="btn-finish-password">
            <button (click)="finish()" [disabled]="!isCheckboxChecked" class="text-white px-4 py-2 rounded" [ngClass]="{
                'bg-purple-600 hover:bg-purple-500 cursor-pointer':
                  isCheckboxChecked,
                'bg-gray-200 cursor-default': !isCheckboxChecked,
              }">
              Finalizar
            </button>
          </div>
        </div>
      </div>
      <!-- END STEP 8 -->

      <!-- Modal HRA Pendente -->
      <div *ngIf="showHraModal" class="fixed inset-0 z-[9999] flex items-center justify-center" style="background: rgba(0,0,0,0.5)">
        <div class="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4">
          <!-- Header -->
          <div class="flex items-center gap-3 mb-4">
            <div class="flex items-center justify-center w-12 h-12 rounded-full" style="background-color: #fff7ed">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#c2410c" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-bold" style="color: #c2410c">HRA Pendente</h3>
              <p class="text-sm" style="color: var(--tx-2)">Questionário de saúde não preenchido</p>
            </div>
          </div>

          <!-- Conteúdo -->
          <div class="rounded-xl p-4 mb-5" style="background-color: #fff7ed; border: 1px solid #fed7aa">
            <p class="text-sm font-semibold mb-2" style="color: #9a3412">
              O paciente não preencheu o questionário de saúde!
            </p>
            <p class="text-sm" style="color: #9a3412">
              Peça ao paciente para preencher o que foi enviado no WhatsApp.
            </p>
            <p class="text-sm mt-2" style="color: #9a3412">
              Justifique que enquanto aguarda o chamado, agiliza o atendimento e ajuda o médico a se preparar.
            </p>
          </div>

          <!-- QR Code da unidade -->
          <div *ngIf="qrCodeHraPath" class="flex flex-col items-center mb-5">
            <p class="text-sm font-semibold mb-3" style="color: var(--brand-accent)">
              Ou peça para escanear o QR Code abaixo:
            </p>
            <img [src]="qrCodeHraPath" alt="QR Code HRA" class="w-48 h-48 rounded-lg" />
          </div>

          <!-- Botões -->
          <div class="flex justify-center gap-3">
            <button (click)="showHraModal = false"
                    class="px-6 py-2.5 rounded-lg text-sm font-semibold"
                    style="color: var(--tx-2); background-color: var(--flua-fundo); border: 1px solid var(--flua-borda)"
                    onmouseover="this.style.backgroundColor='#E5DFD4'"
                    onmouseout="this.style.backgroundColor='#F4F1EA'">
              Descartar
            </button>
            <button (click)="currentStep == 6 ? finishExamCheckIn(pendingSpecialDiscount) : finish()"
                    class="px-6 py-2.5 rounded-lg text-white text-sm font-semibold"
                    style="background-color: var(--brand-secondary)"
                    onmouseover="this.style.filter='brightness(0.9)'"
                    onmouseout="this.style.filter=''">
              Entendi, concluir
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>